import { Box } from '@hover/blueprint';
import React, { useMemo } from 'react';

interface FloatingMenuProps {
  children: React.ReactNode | React.ReactNodeArray;
  targetElementQuerySelector: string;
}

const FloatingMenu = ({
  children,
  targetElementQuerySelector,
}: FloatingMenuProps) => {
  const position = useMemo(() => {
    // find specified target element by label and calculate position based on specified alignment
    const targetElement = document.querySelector(targetElementQuerySelector);
    const boundingCoordinates = targetElement?.getBoundingClientRect();
    return boundingCoordinates;
  }, [targetElementQuerySelector]);

  const cardPosition = useMemo(() => {
    const cardTopPosition = (position?.bottom ?? 0) + 16;
    const cardRightPosition = window.innerWidth - (position?.right ?? 0);

    return { cardTopPosition, cardRightPosition };
  }, [position]);

  return (
    <Box
      background="neutral.0"
      borderRadius={10}
      minWidth={350}
      pointerEvents="auto"
      position="absolute"
      right={`${cardPosition.cardRightPosition}px`}
      testId="floating-menu"
      top={`${cardPosition.cardTopPosition}px`}
    >
      {children}
    </Box>
  );
};

export { FloatingMenu };
